var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"title_wrap"},[_c('h3',[_vm._v(_vm._s(_vm.detailData.title))]),_c('p',[_vm._v(_vm._s(_vm.detailData.addTime))])]),_c('div',{staticClass:"ql-editor content",domProps:{"innerHTML":_vm._s(_vm.detailData.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }